export default __webpack_public_path__ + "static/media/homegif.885c0371.gif";